import { CircularProgress, FormControl, FormHelperText, InputLabel, Select } from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";

function SelectCustom({ children, id, label, value, error, onChange, loading, disabled }) {
  return (
    <FormControl fullWidth>
      <InputLabel id={`label-${id}`} shrink>{label}</InputLabel>
      <Select
        labelId={`label-${id}`}
        label={label}
        id={id}
        value={value}
        error={!!error}
        onChange={onChange}
        IconComponent={() => loading
          ? <CircularProgress color="secondary" size="1.5rem" className="ms-2" />
          : <ArrowDropDown style={{ fontSize: '20px' }} color="secondary" className="ms-2" />
        }
        notched
        displayEmpty
        disabled={disabled}
      >
        {children}
      </Select>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
}

export default SelectCustom;
